<template>
    <v-flex xs12>
        <h1 class="display-2">Indicadores</h1>
        <br>
        <v-layout row>
            <v-flex>
                <v-card>
                    <v-layout>
                        <v-flex>
                            <v-text-field color="grey--text" solo light append-icon="search" label="Búsqueda" hide-details v-model="busqueda"></v-text-field>
                            <v-divider></v-divider>
                            <v-chip class="white--text" :class="[g.color]" v-for="(g,key) in grupos" :key="key" @click.native="grupoSel = g.id">{{ g.titulo }}</v-chip>
                        </v-flex>
                    </v-layout>
                    <v-list three-line>
                        <template v-for="i in filtro">
                            <v-divider></v-divider>
                            <v-list-tile @click.nativ="abrir(i.url)">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ i.titulo }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ i.desc }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>
                                        <template v-for="g in i.grupos">
                                            <span :class="[ g.color + '--text']">{{ g.titulo }}</span> |
                                        </template>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>
    </v-flex>
</template>
<script>
    import indMixins from '../../mixins/indicadores'

    export default {
        mixins: [indMixins],
        data() {
            return {
                indicadores: [],
                busqueda: '',
                grupoSel: '',
                grupos: [],
                busqTipo: 'txt'
            }
        },
        mounted() {
            this.getIndicadores(r => {
                this.indicadores = r
            }, err => {
                console.log(err)
            })
            this.getIndicadoresGrupos(r => {
                this.grupos = r
            }, err => {
                console.log(err)
            })
        },
        computed: {
            filtro() {
                let busqueda = this.busqueda && this.busqueda.toLowerCase()
                let grupo = this.grupoSel;
                let data = this.indicadores;
                let busqTipo = (this.busqueda) ? 'txt' : 'grupo'
                if (busqueda || grupo) {
                    let self = this
                    data = data.filter((row) => {
                        if (busqTipo === 'grupo') {
                            self.grupoSel = ''
                            return row.grupos.some(function (key) {
                                return key.id === grupo
                            })
                        } else {
                            self.busqueda = ''
                            return Object.keys(row).some(function (key) {
                                return String(row[key]).toLowerCase().indexOf(busqueda) > -1
                            })
                        }
                    })
                }
                return data;
            }
        },
        methods: {
            abrir(url) {
                this.$router.push('/indicadores/' + url);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/listado.vue